import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
import { useTranslation } from 'react-i18next';
export function RateselectInput(props) {
  const $ = _c(33);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  const {
    t
  } = useTranslation();
  const t0 = hasError ? errorId : undefined;
  const t1 = hasError ? "true" : "false";
  let t2;
  if ($[0] !== props.label) {
    t2 = <legend className="label mb-2">{props.label}</legend>;
    $[0] = props.label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("forms.rateSelect.no");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <h6 className="text-light-gray-500 text-sm">{t3}</h6>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("forms.rateSelect.yes");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <h6 className="text-light-gray-500 text-sm">{t5}</h6>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="mb-1 flex justify-between">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== props.input || $[14] !== props.options) {
    let t9;
    if ($[16] !== props.input) {
      t9 = (option, i) => <div key={i} className="relative flex-1"><input {...props.input} type="radio" id={`rateSelect-${option}`} value={option} className="peer absolute opacity-0" /><label htmlFor={`rateSelect-${option}`} className="relative flex h-12 w-full cursor-pointer items-center justify-center rounded-lg bg-gray-50 p-2 text-gray-900 transition peer-checked:bg-blue-500 peer-checked:text-white lg:h-16">{option}</label></div>;
      $[16] = props.input;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t8 = props.options.map(t9);
    $[13] = props.input;
    $[14] = props.options;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="flex gap-1 lg:gap-2">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t7 || $[24] !== t9) {
    t10 = <fieldset aria-describedby={t0} aria-invalid={t1}>{t2}{t7}{t9}</fieldset>;
    $[20] = t0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== errorId || $[27] !== hasError || $[28] !== props.meta.error) {
    t11 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[26] = errorId;
    $[27] = hasError;
    $[28] = props.meta.error;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <div className="relative" data-clarity-mask="true">{t10}{t11}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
}